module.exports = __webpack_public_path__ + "img/404.8807fb41.jpg";